import { RiAddLine } from 'react-icons/ri';
import {getError} from "../../helperFunctions"
import { LocationCard } from '../../../components/UiComponents/InfoCards';
import { Button, HelperText } from '../../../components/UiComponents/Ui';
import ErrorEmptyStateView from '../../../components/ErrorEmptyStateView';




const LocationDetails = ({
  setSupplierData,
  handleModalOpen,
  supplierData,
  setModalData,
  formErrors,
}) => {
  const handleRemoveLocation = (index) => {
    setSupplierData((prev) => ({
      ...prev,
      locations: prev?.locations?.filter((_, i) => i !== index),
    }));
  };
  
  const locationsError = getError(['locations'], formErrors);

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="w-[80%] space-y-6 flex flex-col items-center ">
        {supplierData?.locations?.length ? (
          supplierData.locations.map((item, index) => (
            <LocationCard
              key={index}
              item={item}
              onEdit={() => {
                setModalData(item);
                handleModalOpen(true, index);
              }}
              onRemove={() => handleRemoveLocation(index)}
            />
          ))
        ) : (
            <ErrorEmptyStateView
              title="No Location Found"
              description="Please add a location to continue"
              type="empty"
            />
        )}

        <div className="w-[80%]">
          <Button
            fullWidth
            variant="outlined"
            startIcon={<RiAddLine />}
            onClick={() => handleModalOpen(false, 0)}
          >
            Add Location
          </Button>
          {!!locationsError &&typeof locationsError === 'string'  && (
            <HelperText>{locationsError}</HelperText>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;